"use client";
import {useState} from "react";
import {isEmpty, isValidEmail, isValidWebsite} from "@/app/utils/Validations";
import {FormattedMessage} from "react-intl";
import {sendForm} from "@/app/services/FormService";
import styles from "../../../styles/components/pages/partners/partner-contact-form.module.scss";

const ContactForm = () => {
    const [data, setData] = useState({})
    const [errors, setErrors] = useState({})
    const [messageText, setMessageText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [messageSent, setMessageSent] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const formId = '138';

    const resetForm = () => {
        setData({
            name: "",
            phone: "",
            email: "",
            company: "",
            website: "",
            message: ""
        });
        setErrors({});
    }

    const handleChangeData = (name, value) => {
        setData({
            ...data,
            [name]: value
        })
    }
 
    const getFormErrors = () => {

        let formErrors = {}

        if (isEmpty(data?.name)) {
            formErrors.name = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }

        if (isEmpty(data?.phone)) {
            formErrors.phone = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }

        if (isEmpty(data?.company)) {
            formErrors.company = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }

        if (isEmpty(data?.message)) {
            formErrors.message = <FormattedMessage id={'common.errors.thisFieldIsRequired'}/>
        }

        if (!isValidEmail(data?.email)) {
            formErrors.email = <FormattedMessage id={'common.errors.emailIsNotValid'}/>
        }

        if (!isValidWebsite(data?.website)) {
            formErrors.website = <FormattedMessage id={'common.errors.websiteIsNotValid'}/>
        }

        return formErrors
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessageText('')
        const formErrors = getFormErrors()

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }

        setIsLoading(true);
        let formData = new FormData();
        formData.append("your-name", data.name);
        formData.append("your-phone", data.phone);
        formData.append("your-email", data.email);
        formData.append("your-company", data.company);
        formData.append("your-website", data.website);
        formData.append("your-message", data.message);
        formData.append("_wpcf7_unit_tag", "wpcf7-f9246174-1");

        sendForm(formId, formData)
            .then(response => {
                setData({})
                setIsLoading(false);
                setMessageText(response.message);
                resetForm();
                setMessageSent(true);
            })
            .catch(error => {
                setIsLoading(false);
                setFormErrorMessage(common.sendError);
                setMessageSent(false);
            })
    };

    return (
        <>
            <div className={styles.formContainer}>
                <form onSubmit={handleSubmit} className="formStyle">
                    <div className="inputContainer">
                        <FormattedMessage id={'components.pages.partners.contactForm.name'}>
                            {(message) =>
                                <input
                                    id="name-input"
                                    type="text"
                                    value={data.name}
                                    placeholder={message}
                                    autoComplete="off"
                                    onChange={(e) => handleChangeData('name', e.target.value)}
                                />
                            }
                        </FormattedMessage>
                        {errors?.name && <div className="errorMessage">{errors?.name}</div>}
                    </div>
                    <div className="inputContainer">
                        <FormattedMessage id={'components.pages.partners.contactForm.phone'}>
                            {(message) =>
                               <input
                                    id="phone-input"
                                    type="tel"
                                    value={data.phone}
                                    placeholder={message}
                                    autoComplete="off"
                                    onChange={(e) => handleChangeData('phone', e.target.value)}
                                />
                            }
                        </FormattedMessage>
                        {errors?.phone && <div className="errorMessage">{errors?.phone}</div>}
                    </div>
                    <div className="inputContainer">
                        <FormattedMessage id={'components.pages.partners.contactForm.email'}>
                            {(message) =>
                                <input
                                    id="email-input"
                                    type="email"
                                    value={data.email}
                                    placeholder={message}
                                    autoComplete="off"
                                    onChange={(e) => handleChangeData('email', e.target.value)}
                                />
                            }
                        </FormattedMessage>
                        {errors?.email && <div className="errorMessage">{errors?.email}</div>}
                    </div>
                    <div className="inputContainer">
                        <FormattedMessage id={'components.pages.partners.contactForm.company'}>
                            {(message) =>
                                <input
                                    id="company-input"
                                    type="text"
                                    value={data.company}
                                    placeholder={message}
                                    autoComplete="off"
                                    onChange={(e) => handleChangeData('company', e.target.value)}
                                />
                            }
                        </FormattedMessage>
                        {errors?.company && <div className="errorMessage">{errors?.company}</div>}
                    </div>
                    <div className="inputContainer">
                        <FormattedMessage id={'components.pages.partners.contactForm.website'}>
                            {(message) =>
                                <input
                                    id="website-input"
                                    type="text"
                                    value={data.website}
                                    placeholder={message}
                                    autoComplete="off"
                                    onChange={(e) => handleChangeData('website', e.target.value)}
                                />
                            }
                        </FormattedMessage>
                        {errors?.website && <div className="errorMessage">{errors?.website}</div>}
                    </div>
                    <div className="inputContainer">
                        <FormattedMessage id={'components.pages.partners.contactForm.message'}>
                            {(message) =>
                                <textarea
                                    id="message-input"
                                    value={data.message}
                                    placeholder={message}
                                    onChange={(e) => handleChangeData('message', e.target.value)}
                                />
                            }
                        </FormattedMessage>
                        {errors?.message && <div className="errorMessage">{errors?.message}</div>}
                    </div>
                    <div className="buttonContainer">
                        <button className="submit-btn btnGlobal"><FormattedMessage id={'common.send'}/></button>
                    </div>
                    {isLoading && <div className="sending"><FormattedMessage id={'common.sending'}/></div>}
                    {messageSent && <div className="success-message">{messageText}</div>}
                    {formErrorMessage && <div className="error-message-2">{formErrorMessage}</div>}
                </form>
            </div>
        </>
    );
};

export default ContactForm;
